import CoronarografiaPtcaEdit from "./components/CoronarografiaPtcaEdit.vue";
import CoronarografiaPtcaView from "./components/CoronarografiaPtcaView.vue";
import CoronarografiaPtcaList from "./components/CoronarografiaPtcaList.vue";

export default {
    CoronarografiaPtcaEdit,
    CoronarografiaPtcaView,
    CoronarografiaPtcaList,
};
